import React from 'react';
import _get from 'lodash/get';
import { Site } from 'graphql-common';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import SiteChip from '@lib/components/SiteChip/SiteChip';
import { ChipSizes } from '@lib/components/Chip/Chip';
import { SelectPanelOptionRendererProps } from '../types';
import styles from '../SelectPanel.module.scss';

export function SiteOption({
  option,
  isSelected,
  isMulti,
}: SelectPanelOptionRendererProps): React.ReactElement {
  const site = _get(option, 'data') as Site;

  // Returns a Fragment (checkbox + content) so both slot directly into the
  // SelectPanel option button's own grid — wrapping them in a single element
  // collapses the content into the button's min-content column.
  return (
    <>
      {isMulti && (
        <span className={styles.optionCheckbox}>
          <MaterialIcon
            icon={isSelected ? 'check_box' : 'check_box_outline_blank'}
            size="md-18"
          />
        </span>
      )}
      <span className={styles.entityOptionChipContent}>
        <SiteChip site={site} size={ChipSizes.small} />
      </span>
    </>
  );
}
